import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Region } from "../types/region";
import { codeToFlag } from "../utils/code-to-flag";

interface RegionTableProps {
  regions: Region[];
  onRowClick: (region: Region) => void;
}

export default function RegionTable({ regions, onRowClick }: RegionTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Region</TableHead>
          <TableHead>Currency</TableHead>
          <TableHead>Timezone</TableHead>
          <TableHead>Locale</TableHead>
          <TableHead>Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {regions.map((region) => (
          <TableRow
            key={region.id}
            className="cursor-pointer"
            onClick={() => onRowClick(region)}
          >
            <TableCell>
              <span className="mr-2">{codeToFlag(region.code)}</span>
              {region.display_name}{" "}
              <span className="uppercase text-muted-foreground">
                ({region.code})
              </span>
              {region.is_fallback && (
                <Badge className="ml-2 bg-blue-100 text-blue-800 border-blue-200">
                  Fallback · ROW
                </Badge>
              )}
            </TableCell>
            <TableCell>{region.currency}</TableCell>
            <TableCell>{region.timezone}</TableCell>
            <TableCell>{region.default_locale}</TableCell>
            <TableCell>
              <Badge
                className={
                  region.is_active
                    ? "bg-green-100 text-green-800 border-green-200"
                    : "bg-gray-100 text-gray-700 border-gray-200"
                }
              >
                {region.is_active ? "Active" : "Inactive"}
              </Badge>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
